<template>
  <div id="machinLeaseContract" v-loading="loading">
    <div class="buttons" v-loading="loading">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContractD"
        style="margin: 10px 0"
        >打印 </el-button
      ><el-button
        type="primary"
        icon="el-icon-plus"
        @click="saveContractA"
        style="margin: 10px 10px"
        v-if="dialogForm.approveStatus != 3 && dialogForm.approveStatus != 2"
        >保存
      </el-button>
      <el-button type="primary" @click="setWatermark" style="margin: 10px 0"
        >设置水印
      </el-button>
      <div style="display: inline-flex; width: 300px;margin-left:150px;">
        <el-input v-model="inputPages" placeholder="总页数" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputHeight" placeholder="单页高" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputPosx" placeholder="偏移量" style="margin-left: 10px;"></el-input>
      </div>
    </div>
    <div
      ref="HTMLmachinLeaseContent"
      id="HTMLmachinLeaseContent"
      :class="printClass"
      :key="printClass"
    >
      <div class="machinLeaseContract1">
        <!-- <p style="line-height: 37px">
          <br />
        </p> -->
        <p style="text-align: center; line-height: 31px">
          <strong
            ><span style="font-family: 黑体; font-size: 24px"
              ><span style="font-family: 黑体">设备租赁合同</span>
            </span></strong
          >
        </p>
        <p style="line-height: 37px">
          <strong
            ><span style="font-family: 仿宋; font-size: 21px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
            ></strong
          >
        </p>
        <p style="line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >合同编号：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="serialNumber"
              >{{
                detailForm.serialNumber ? detailForm.serialNumber : ""
              }}</span
            ></span
          >
        </p>
        <p style="line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >签约地点：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="signPlace"
              >{{ detailForm.signPlace }}</span
            ></span
          >
        </p>
        <p style="line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >甲方（承租方）：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 340px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="partyA"
              >{{ detailForm.partyA || "青岛路桥建设集团有限公司" }}</span
            ></span
          >
        </p>
        <p style="line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >乙方（出租方）：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 340px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="partyB"
              >{{ detailForm.partyB ? detailForm.partyB : "" }}</span
            ></span
          >
        </p>
        <p style="line-height: 37px">
          <strong
            ><span style="font-family: 仿宋; font-size: 21px"
              >&nbsp;&nbsp;</span
            ></strong
          ><span style="font-family: 仿宋; font-size: 21px"
            >&nbsp;&nbsp;<span style="font-family: 仿宋"
              >根据《中华人民共和国民法典》等相关法律法规的规定，甲乙双方在平等自愿、互利互惠的基础上，为明确双方权利义务，经双方协商一致，特签订以下合同条款。</span
            ></span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 黑体; font-size: 21px"
              >一、合同租赁物</span
            ></strong
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >1.本合同的租赁物为：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 5cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="htzlw"
              >{{ detailForm.htzlw }}</span
            ></span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >2.租赁物具体情况描述如下表：</span
          >
        </p>
        <table
          ref="machinLeaseTable"
          width="100%"
          :key="tableKey"
          style="border-collapse: collapse; border-width: 1px"
        >
          <thead style="display: table-header-group">
            <tr style="height: 37px" class="firstRow">
              <td
                width="94"
                valign="center"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 37px">
                  <span style="font-family: 仿宋; font-size: 19px"
                    >设备名称</span
                  >
                </p>
              </td>
              <td
                width="94"
                valign="center"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 37px">
                  <span style="font-family: 仿宋; font-size: 19px"
                    >设备型号</span
                  >
                </p>
              </td>
              <td
                width="57"
                valign="center"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 37px">
                  <span style="font-family: 仿宋; font-size: 19px">数量</span>
                </p>
              </td>
              <td
                width="117"
                valign="center"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="line-height: 37px">
                  <span style="font-family: 仿宋; font-size: 19px"
                    >月租金（元）</span
                  >
                </p>
              </td>
              <td
                width="95"
                valign="center"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 37px">
                  <span style="font-family: 仿宋; font-size: 19px"
                    >计租时间</span
                  >
                </p>
              </td>
              <td
                width="134"
                valign="center"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="line-height: 37px">
                  <span style="font-family: 仿宋; font-size: 19px"
                    >租赁期（暂定）</span
                  >
                </p>
              </td>
              <td
                width="62"
                valign="center"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                "
              >
                <p style="text-align: center; line-height: 37px">
                  <span style="font-family: 仿宋; font-size: 19px">备注</span>
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              style="
                height: 33px;
                page-break-inside: avoid;
                page-break-before: auto;
              "
              v-for="(item, index) in machinLeasetableList"
              :key="item.id"
            >
              <td
                width="94"
                valign="center"
                v-if="index != machinLeasetableList.length - 1"
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column0 }}
              </td>
              <td
                v-else
                width="653"
                valign="top"
                colspan="7"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                v-html="item.column0"
              ></td>
              <td
                width="94"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                v-if="index != machinLeasetableList.length - 1"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column1 }}
              </td>
              <td
                width="57"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                v-if="index != machinLeasetableList.length - 1"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column2 }}
              </td>
              <td
                width="117"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                v-if="index != machinLeasetableList.length - 1"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column3 }}
              </td>
              <td
                width="95"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                v-if="index != machinLeasetableList.length - 1"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column4 }}
              </td>
              <td
                width="134"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                v-if="index != machinLeasetableList.length - 1"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column5 }}
              </td>
              <td
                width="62"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                v-if="index != machinLeasetableList.length - 1"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column6 }}
              </td>
            </tr>
          </tbody>
        </table>
        <div
          style="display: flex"
          v-if="dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="添加行"
            placement="top-start"
          >
            <i class="el-icon-plus" @click="addItem"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除行"
            placement="top-start"
          >
            <i class="el-icon-minus" @click="delItem"></i>
          </el-tooltip>
        </div>
        <p style="text-indent: 42px; line-height: 37px">
          <strong
            ><span style="font-family: 仿宋; font-size: 21px"
              >注：不含税单价固定不变，税金随着国家规定税率的调整而调整，最终税金金额以开具发票时的国家税率计算为准。</span
            ></strong
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >3.乙方出租的<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 3cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contents"
              >{{ detailForm.contents }}</span
            >应符合国家、行业规定的质量标准，符合合同约定或甲方所承建的建设工程施工需要。（租赁物需具有相应生产厂家出厂质量合格证书、已使用年限证明）</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 30px">
          <span style="font-family: 仿宋; font-size: 21px"
            >4.其他约定&nbsp;<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                padding-bottom: 2px;
                line-height: 32px;
                word-break: break-all;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="qtyd1"
              >&nbsp;{{ detailForm.qtyd1 || "无" }}</span
            ></span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 黑体; font-size: 21px"
              >二、租赁期限</span
            ></strong
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >1.租赁期限暂定为<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="limitTime"
              >{{ detailForm.limitTime }}</span
            >月。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >2.实际租赁期限以实际使用期限为准。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 30px">
          <span style="font-family: 仿宋; font-size: 21px"
            >3.租赁其他约定：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                padding-bottom: 2px;
                line-height: 32px;
                word-break: break-all;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="zlqtyd1"
              >&nbsp;{{ detailForm.zlqtyd1 || "无" }}</span
            ></span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 黑体; font-size: 21px"
              >三、租赁物权属</span
            ></strong
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >1.在租赁期限内，租赁物所有权属于乙方，甲方仅对其拥有使用权。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >2.租赁期限内，乙方将租赁物转让、抵押给第三方，应在转让、抵押事实发生之日起<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1.5cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="limitDay"
              >{{ detailForm.limitDay }}</span
            >日内书面通知甲方，甲方不因此丧失租赁物的使用权。如第三方在取得租赁物所有权后要求终止本合同或改变租金等，致使甲方使用租赁物受到相应的限制，乙方应向甲方支付按租金总额30%计算的违约金并赔偿因此给甲方造成的全部损失。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >3.租赁期限内，乙方不得就租赁物与其他任何第三方签订租赁合同，将租赁物重复出租，由于第三方的行为致使甲方丧失租赁物使用权或遭受其他损失的，应向甲方支付按租金总额30%计算的违约金并赔偿因此给甲方造成的全部损失。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 黑体; font-size: 21px"
              >四、租赁物使用地点</span
            ></strong
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >甲方建设工程施工地点<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 6cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="zlwsydd"
              >{{ detailForm.zlwsydd }}</span
            >为本合同租赁物使用地点。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 黑体; font-size: 21px"
              >五、租金、相关费用及支付</span
            ></strong
          >
        </p>
        <p style="text-indent: 42px; line-height: 30px">
          <span style="font-family: 仿宋; font-size: 21px"
            >1.甲乙双方选择如下租金及支付方式：</span
          >
        </p>
        <p style="line-height: 30px; font-family: 仿宋; font-size: 21px">
          <span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              padding-bottom: 2px;
              line-height: 32px;
              word-break: break-all;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="zjhzffs1"
            >{{ detailForm.zjhzffs1 || "无" }}</span
          >
        </p>

        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >2.进场和退场所产生的运输费由乙方负担。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >3.乙方收款时应提供相应金额的符合集团公司财务审计部要求的合法发票，否则甲方有权拒付相应款项直至乙方能提供符合规定的发票为止。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 黑体; font-size: 21px"
              >六、租赁物的日常操作及维护</span
            ></strong
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >1.在租赁期限内，乙方负责租赁物的日常维护修理工作，保证甲方正常施工的使用，其间所发生的维护修理费用，由乙方自行负担。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 30px">
          <span style="font-family: 仿宋; font-size: 21px"
            >2.对维护修理的其他约定：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                padding-bottom: 2px;
                line-height: 32px;
                word-break: break-all;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="whxlqtyd1"
              >&nbsp;{{ detailForm.whxlqtyd1 || "无" }}</span
            ></span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 黑体; font-size: 21px"
              >七、甲乙双方的权利义务</span
            ></strong
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 楷体; font-size: 21px"
              ><span style="font-family: 楷体">第一条</span>
              <span style="font-family: 楷体">甲方职责</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >1.甲方负责提供放置租赁物的场地，提供租赁物进场、退场的道路通畅。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >2.机械进入施工现场作业前，甲方对所租机械进行全面验收，并履行验收手续，需有相关记录。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >3.机械使用前，甲方应将机械工作范围、设施的保护及相关注意事项，向乙方进行安全交底。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >4.甲方须设专职机械设备管理人员，负责组织机械调配，并负责施工过程中进行分部、分项的安全技术交底。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >5.甲方有权对乙方进行监督、检查，对乙方存在的安全隐患有权提出批评和限期整改意见。对限期不改者，可依据甲方相关安全管理制度要求乙方承担违约责任支付违约金。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >6.甲方对外租机械检查中发现的问题，及时通知乙方，乙方有关人员应及时处理，甲方对不符施工要求的设备有权清退。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >7.甲方发现乙方存在较为严重的安全隐患时，有可能对人身造成伤害时，有权停止施工作业。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >8.租赁期限内，未经乙方同意，甲方不得将租赁物转租或转让、抵押给第三方，因此而造成的损失由甲方承担。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 楷体; font-size: 21px"
              ><span style="font-family: 楷体">第二条</span>
              <span style="font-family: 楷体">乙方职责</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >1.保证提供的租赁物为正规生产厂家生产，符合建设工程租赁物使用的行业规定，质量不存在任何暇疵确保机械的安全技术性能符合安全要求。因乙方提供的租赁物质量不合格、或其他归责于乙方的原因，造成甲方员工人身损害或财产损失的，乙方应赔偿全部损失并承担相应的法律责任。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >2.乙方负责租赁物的进退场运输工作，保证在合同约定的时间，将租赁物运输并装卸在甲方指定的地点。乙方未将租赁物租于甲方或乙方未能按时送达租赁物至甲方指定地点进行安装的，乙方向甲方支付合同总价款50%违约金。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >3.需向甲方提供安全管理制度及安全保证措施。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >4.保证所提供安全的机械及设备防护部件100％的完好率。并负责机械的日常维护保养，对安全工作负全责。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >5.保证甲方正常机械使用的需要，禁止机械带病和防护设备不齐全设备进场作业。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >6.保证机械操作人员持有效操作证件及时到岗，随机配备人员必须服从甲方现场指挥人员的调配，满足施工需要。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >7.乙方特种作业人员，应持证上岗，负责安全教育和安全检查工作，为员工配备必要的劳动防护用品及合格有效的安全工、器具，并监督教育员工正确使用。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >8.乙方应随时接受甲方的安全监督检查，对甲方查出问题负责及时整改。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >9.乙方在接近带电设备作业时，应保证安全距离，采取安全措施，必须指定专人现场监护、指挥。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >10.租赁使用过程中，因乙方设备本身原因或人为因素发生人身伤亡事故、机械事故、材料损坏事故，乙方应承担事故责任等法律责任并赔偿因此造成的全部损失。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >11.乙方在作业时，应对施工现场地上管线和设备负责保护，发现地下不明物应告知甲方，并进行有效地保护，不得损坏。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >12.双方确定租赁物退场时间后，乙方未能按约定运输租赁物离开甲方施工场地的，乙方每迟延一日向甲方支付合同总价款10%的违约金。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 楷体; font-size: 21px"
              ><span style="font-family: 楷体">第三条</span>
              <span style="font-family: 楷体">乙方提供的资料</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >1.企业资质证明，营业执照复印件。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >2.乙方向甲方提供租赁物生产厂家名称，租赁物使用年限证明，机械设备出厂合格证（机械名称、型号、厂家、出厂编号日期）。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >3.进场作业人员身份证及花名册，特种作业人员操作证。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 楷体; font-size: 21px"
              ><span style="font-family: 楷体">第四条</span>
              <span style="font-family: 楷体">赔偿责任</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >1.施工过程中，因乙方或乙方工作人员管理不善或操作不当等原因造成事故的，由乙方承担全部责任并负责善后处理。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >2.施工过程因乙方没按现场施工人员要求工作，而引发安全生产事故，造成的经济损失，由乙方负全部责任，约定的违约金低于甲方损失的，不足部分由乙方据实赔偿或甲方从应付款中直接抵扣，不足以抵扣的部分，乙方仍应承担，并承担甲方因追究乙方违约责任而产生的所有费用，包括但不限于通知公告费用、律师咨询代理费用、公证费用等。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >3.乙方因违反安全操作规程，发生安全生产事故，而造成的经济损失，全部由乙方负责赔偿，约定的违约金低于甲方损失的，不足部分由乙方据实赔偿或甲方从应付款中直接抵扣，不足以抵扣的部分，乙方仍应承担，并承担甲方因追究乙方违约责任而产生的所有费用，包括但不限于通知公告费用、律师咨询代理费用、公证费用等。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >4.乙方违反安全技术操作规程，造成机械设备损失，致使甲方不能正常使用机械设备，乙方应赔偿由此给甲方造成的全部经济损失，约定的违约金低于甲方损失的，不足部分由乙方据实赔偿或甲方从应付款中直接抵扣，不足以抵扣的部分，乙方仍应承担，并承担甲方因追究乙方违约责任而产生的所有费用，包括但不限于通知公告费用、律师咨询代理费用、公证费用等。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >5.外租机械设备因乙方管理不善，而造成的经济损失由乙方自行负责。甲方不承担任何责任。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 黑体; font-size: 21px"
              >八、补充约定</span
            ></strong
          >
        </p>
        <p style="line-height: 30px; font-family: 仿宋; font-size: 21px">
          <span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              padding-bottom: 2px;
              line-height: 32px;
              word-break: break-all;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="bcyd1"
            >{{ detailForm.bcyd1 || "无" }}</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 黑体; font-size: 21px"
              >九、不可抗力</span
            ></strong
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >1.本合同履行过程中出现不可抗力是指合同签订时不能预见、不能避免、不能克服的自然客观情况。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >2.合同履行过程中出现不可抗力情形，致使一方或双方不能履行合同约定条款时，不能履行方应在不可抗力情形发生之日起3日内向对方书面通知，在取得合法机关有效证明后，根据不可抗力对合同履行的影响程度，经另一方同意后，履行方可延期履行、部分履行或不履行合同义务，并可根据情况部分或全部免除履行方责任。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >3.合同迟延履行所发生的不可抗力，履行方不免除责任，并必须承担迟延履行的违约责任。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 黑体; font-size: 21px"
              >十、其他约定</span
            ></strong
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >1.租赁期届满，双方同意续租的，由双方另行签订合同约定相关事宜，或签订本协议补充协议。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >2.合同签订时，甲、乙双方互相提供营业执照（合法身份证明）复印件、法定代表人证明、安装资质、授权委托书等相关材料，以上材料均需加盖公章。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >3.本合同签订时需甲方（授权代表）签字认可，否则本合同不产生法律效力。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >4.本合同的签订，除甲方（授权代表）签字或盖章认可的，甲方的其他工作人员不能代表甲方处理因本合同引起的债权债务，擅自处理债权债务行为包括但不限于出具欠款证明、对帐单据等等，因此而产生的债权债务甲方不予认可，且对甲方不产生法律效力。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 黑体; font-size: 21px"
              >十一、争议的解决</span
            ></strong
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >1.凡因本合同履行产生的一切争议，甲乙双方本着互利互惠的态度，通过友好协商解决争议。如协商不能达成一致，双方中任何一方可向合同签订地有管辖权的人民法院提起诉讼。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >2.乙方承担为解决争议而支付的所有费用，包括但不限于诉讼费、律师费、评估费、鉴定费、审计费、差旅费等。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <strong
            ><span style="font-family: 黑体; font-size: 21px"
              >十二、合同效力及其他</span
            ></strong
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >1.本合同自甲乙双方授权代表签字并加盖公章之日起生效。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >2.本合同一式<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractTotal"
              >{{ detailForm.contractTotal }}</span
            >份，甲方执<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractAnum"
              >{{ detailForm.contractAnum }}</span
            >份，乙方执<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractBnum"
              >{{ detailForm.contractBnum }}</span
            >份同具法律效力。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >3.本合同未尽事宜，双方另行签订补充协议，补充协议于本合同同时使用，具有同等法律效力，补充合同与本合同矛盾的，以补充合同为准。</span
          >
        </p>
        <p style="text-indent: 43px; line-height: 37px">
          <span style="font-family: 仿宋; font-size: 21px"
            >4.本合同的附件包括双方的资格资料、送货收货清单、来往帐单、支付证明等，与本合同同时使用，具有同等法律效力。</span
          >
        </p>
        <p style="line-height: 29px">
          <span style="font-family: 宋体; font-size: 16px">&nbsp;</span>
        </p>
        <div style="display: flex; font-family: 仿宋; font-size: 21px">
          <div style="width: 340px">
            <p style="line-height: 29px">
              <span style="font-family: 仿宋">甲方（盖章）：</span>
              <span
                class="partA_gongzhang"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                >{{ detailForm.partA_gongzhang }}</span
              >
            </p>
            <p style="line-height: 20px">
              <span style="font-family: 仿宋; font-size: 21px">&nbsp;</span>
            </p>
            <p style="line-height: 29px">
              <span style="font-family: 仿宋; font-size: 21px"
                ><span style="font-family: 仿宋">授权代表：</span
                ><span
                  class="partA_sign"
                  :contenteditable="
                    dialogForm.approveStatus != 2 &&
                    dialogForm.approveStatus != 3
                  "
                  >{{ detailForm.partA_sign }}</span
                ></span
              >
            </p>

            <!-- <p style="line-height: 29px">
              <span style="font-family: 仿宋; font-size: 21px">&nbsp;</span>
            </p> -->
            <p style="line-height: 20px; font-family: 仿宋; font-size: 21px">
              <span>日期：</span
              ><span
                class="partA_date"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                >{{ detailForm.partA_date }}</span
              >
            </p>
          </div>
          <div style="width: 360px">
            <p style="line-height: 29px">
              <span style="font-family: 仿宋">乙方（盖章）：</span>
              <span
                class="partB_gongzhang"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                >{{ detailForm.partB_gongzhang }}</span
              >
            </p>
            <p style="line-height: 20px">
              <span style="font-family: 仿宋; font-size: 21px">&nbsp;</span>
            </p>
            <p style="line-height: 29px">
              <span style="font-family: 仿宋; font-size: 21px"
                ><span style="font-family: 仿宋">授权代表：</span
                ><span
                  class="partB_sign"
                  :contenteditable="
                    dialogForm.approveStatus != 2 &&
                    dialogForm.approveStatus != 3
                  "
                  >{{ detailForm.partB_sign }}</span
                ></span
              >
            </p>

            <!-- <p style="line-height: 29px">
              <span style="font-family: 仿宋; font-size: 21px">&nbsp;</span>
            </p> -->
            <p style="line-height: 20px; font-family: 仿宋; font-size: 21px">
              <span>日期：</span
              ><span
                class="partB_date"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                >{{ detailForm.partB_date }}</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="printWrap" v-show="false">
      <div
        v-html="machinLeaseContent"
        class="mainHtml"
        id="printmachinLeaseContent"
      ></div>
    </div>

    <setWatermarkDialog
      ref="setWatermarking"
      @setWaterMarkFun="setWaterMarkFun"
    ></setWatermarkDialog>
  </div>
</template>

<script>
import {
  getServiceContractDetailService, //获取合同填充内容
} from "@/services/allContractServices";
import printJS from "print-js";
import { mixins } from "@/page/contract/template/mixin.js";
import setWatermarkDialog from "../../commonCell/setWatermarkDialog.vue";
import { addPageNum, getTableData } from "../common.js";
import { addPageNumCustom } from "../common.js";

export default {
  name: "machinLeaseContract",
  mixins: [mixins],
  components: {
    setWatermarkDialog,
  },
  data() {
    return {
      machinLeaseContent: "", //富文本编辑器内容
      watermark: [""],
      list: [1, 2, 3, 4, 5, 6, 7, 8],
      saveflag: false,
      detailForm: { ...this.dialogForm },
      tableKey: Math.random(),
      machinLeasetableList: [
        {
          id: 1,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 2,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 3,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 4,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
        },
        {
          id: 5,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
        },
        {
          id: 6,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
        },
        {
          id: 7,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
        },
        {
          id: 2000,
          column0: ` <p
                  style="line-height: 32px; font-family: 仿宋; font-size: 21px"
                >
                  合计总费用：<span style="text-decoration: underline">含税总价： &nbsp;&nbsp;&nbsp;&nbsp;元（大写
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;）（不含税价：&nbsp;&nbsp;&nbsp;&nbsp;，税率： &nbsp;，税金：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;）</span>
                </p>`,
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
        },
      ], //中间表格数据
      inputPages: "",
      inputHeight: 1010,
      inputPosx: 37,
    };
  },
  methods: {
    addItem() {
      let len = this.machinLeasetableList.length - 2;
      let id = (this.machinLeasetableList[len]?.id ?? 0) + 1;
      let item = {
        id: id,
        column0: "",
        column1: "",
        column2: "",
        column3: "",
        column4: "",
        column5: "",
        column6: "",
      };
      this.machinLeasetableList.splice(len + 1, 0, item);
    },
    delItem() {
      if (this.machinLeasetableList.length > 1)
        this.machinLeasetableList.splice(-2, 1);
    },
    /**
     * 初始化全部订单表格数据,配置表格列等数据
     *
     **/
    initOrderDetailTable() {
      this.getTableData();
    },
    //获取一条劳务合同信息
    getsubServiceContractDetail(id) {
      if (!id) return;
      let param = {};
      param.id = id;
      getServiceContractDetailService(param)
        .then((res) => {
          if (res.code == 10000000) {
            let data = {};
            if (res.data.subContractPrintVO) {
              data = res.data.subContractPrintVO;
              this.watermark = res.data.subContractPrintVO.watermark || [""];
              if (data.content) {
                this.saveflag = true;
                this.detailForm = JSON.parse(data.content);
                if (this.detailForm.machinLeasetableList)
                  this.machinLeasetableList = JSON.parse(
                    this.detailForm.machinLeasetableList
                  );
                this.machinLeasetableList.forEach((item, index) => {
                  if (index == this.machinLeasetableList.length - 1) {
                    item.id = 2000;
                  } else {
                    item.id = index + 1;
                  }
                  return item;
                });
              } else {
                this.detailForm = { ...this.dialogForm };
                this.machinLeasetableList = [
                  {
                    id: 1,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 2,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 3,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 4,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                  },
                  {
                    id: 5,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                  },
                  {
                    id: 6,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                  },
                  {
                    id: 7,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                  },
                  {
                    id: 2000,
                    column0: ` <p
                  style="line-height: 32px; font-family: 仿宋; font-size: 21px"
                >
                  合计总费用：<span style="text-decoration: underline">含税总价： &nbsp;&nbsp;&nbsp;&nbsp;元（大写
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;）（不含税价：&nbsp;&nbsp;&nbsp;&nbsp;，税率： &nbsp;，税金：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;）</span>
                </p>`,
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                  },
                ];
              }
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
          this.loading=false;
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
          this.loading=false;
        });
    },
    /**
     * 关闭当前tab页面
     */
    closePage() {
      this.bus.$emit("tabClose", "order-detail");
    },
    ClosePrintOrder() {
      this.orderbillNo = [];
      this.orderDetailList = [];
    },
    saveContractA() {
      if (this.detailForm.approveStatus == 2) {
        this.$alert("合同为待审核无法修改", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // this.getValues();
      const table = this.$refs.machinLeaseTable;
      this.machinLeasetableList = getTableData(
        table,
        this.machinLeasetableList,
        7
      );
      this.detailForm.machinLeasetableList = JSON.stringify(
        this.machinLeasetableList
      );
      this.tableKey = Math.random();
      this.saveCommon('machinLeaseContract');
    },
    getValues() {
      // let Id = document.getElementById("HTMLmachinLeaseContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      this.detailForm.serialNumber =
        Id.getElementsByClassName("serialNumber")[0].innerText.trim();
      this.detailForm.partyA =
        Id.getElementsByClassName("partyA")[0].innerText.trim();
      this.detailForm.partyB =
        Id.getElementsByClassName("partyB")[0].innerText.trim();
      this.detailForm.signPlace =
        Id.getElementsByClassName("signPlace")[0].innerText.trim();
      Id.getElementsByClassName("signPlace")[0].innerHTML =
        this.detailForm.signPlace;

      this.detailForm.htzlw =
        Id.getElementsByClassName("htzlw")[0].innerText.trim();
      Id.getElementsByClassName("htzlw")[0].innerHTML = this.detailForm.htzlw;

      this.detailForm.contents =
        Id.getElementsByClassName("contents")[0].innerText.trim();
      this.detailForm.qtyd1 = Id.getElementsByClassName("qtyd1")[0].innerText;

      this.detailForm.limitTime =
        Id.getElementsByClassName("limitTime")[0].innerText.trim(); //租赁期限
      this.detailForm.zlqtyd1 =
        Id.getElementsByClassName("zlqtyd1")[0].innerText;
      this.detailForm.limitDay =
        Id.getElementsByClassName("limitDay")[0].innerText.trim();
      this.detailForm.zlwsydd =
        Id.getElementsByClassName("zlwsydd")[0].innerText.trim();

      this.detailForm.zjhzffs1 =
        Id.getElementsByClassName("zjhzffs1")[0].innerText;

      this.detailForm.whxlqtyd1 =
        Id.getElementsByClassName("whxlqtyd1")[0].innerText;
      this.detailForm.bcyd1 = Id.getElementsByClassName("bcyd1")[0].innerText;

      this.detailForm.contractTotal =
        Id.getElementsByClassName("contractTotal")[0].innerText.trim();
      this.detailForm.contractAnum =
        Id.getElementsByClassName("contractAnum")[0].innerText.trim();
      this.detailForm.contractBnum =
        Id.getElementsByClassName("contractBnum")[0].innerText.trim();

      Id.getElementsByClassName("contents")[0].innerHTML =
        this.detailForm.contents;
      Id.getElementsByClassName("qtyd1")[0].innerHTML = this.detailForm.qtyd1;
      Id.getElementsByClassName("limitTime")[0].innerHTML =
        this.detailForm.limitTime;
      Id.getElementsByClassName("zlqtyd1")[0].innerHTML =
        this.detailForm.zlqtyd1;
      Id.getElementsByClassName("limitDay")[0].innerHTML =
        this.detailForm.limitDay;

      Id.getElementsByClassName("zlwsydd")[0].innerHTML =
        this.detailForm.zlwsydd;
      Id.getElementsByClassName("zjhzffs1")[0].innerHTML =
        this.detailForm.zjhzffs1;
      Id.getElementsByClassName("whxlqtyd1")[0].innerHTML =
        this.detailForm.whxlqtyd1;
      Id.getElementsByClassName("bcyd1")[0].innerHTML = this.detailForm.bcyd1;

      Id.getElementsByClassName("contractTotal")[0].innerText =
        this.detailForm.contractTotal;
      Id.getElementsByClassName("contractAnum")[0].innerText =
        this.detailForm.contractAnum;
      Id.getElementsByClassName("contractBnum")[0].innerText =
        this.detailForm.contractBnum;

      this.detailForm.partA_gongzhang =
        Id.getElementsByClassName("partA_gongzhang")[0].innerText;
      Id.getElementsByClassName("partA_gongzhang")[0].innerHTML =
        this.detailForm.partA_gongzhang;
      this.detailForm.partA_sign =
        Id.getElementsByClassName("partA_sign")[0].innerText;
      Id.getElementsByClassName("partA_sign")[0].innerHTML =
        this.detailForm.partA_sign;
      this.detailForm.partA_date =
        Id.getElementsByClassName("partA_date")[0].innerText;
      Id.getElementsByClassName("partA_date")[0].innerHTML =
        this.detailForm.partA_date;

      this.detailForm.partB_gongzhang =
        Id.getElementsByClassName("partB_gongzhang")[0].innerText;
      Id.getElementsByClassName("partB_gongzhang")[0].innerHTML =
        this.detailForm.partB_gongzhang;
      this.detailForm.partB_sign =
        Id.getElementsByClassName("partB_sign")[0].innerText;
      Id.getElementsByClassName("partB_sign")[0].innerHTML =
        this.detailForm.partB_sign;
      this.detailForm.partB_date =
        Id.getElementsByClassName("partB_date")[0].innerText;
      Id.getElementsByClassName("partB_date")[0].innerHTML =
        this.detailForm.partB_date;
    },
    
    //打印当前合同
    PrintContractD() {
      if (this.dialogForm.approveStatus != 3) {
        this.$alert("合同尚未通过审核，无法打印", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // let Id = document.getElementById("HTMLmachinLeaseContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      let elementsToRemove = Id.querySelectorAll(".page-num");
      elementsToRemove.forEach((element) => {
        element.parentNode.removeChild(element);
      });
      //addPageNum(Id, 0, "machinLeaseContent");
      addPageNumCustom(Id, 0, "machinLeaseContent", this.inputPages, this.inputHeight, this.inputPosx);
      
      this.$set(
        this,
        "machinLeaseContent",
        this.$refs.HTMLmachinLeaseContent.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printmachinLeaseContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
          style: `@page { size: auto;  margin:10mm} p{line-height: 29px} .machinLeaseContract1 {background: url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50%25' y='50%25' font-size='14' fill-opacity='0.3' text-anchor='middle' dominant-baseline='middle' transform='rotate(-35, 100 100)'%3E${this.watermark.join(
            ";"
          )}%3C/text%3E%3C/svg%3E");
}`,
        });
      });
    },
    //设置水印
    setWatermark() {
      this.$refs.setWatermarking.showwaterMarkDialog(
        this.subServiceContractId,
        this.watermark
      );
    },
    setWaterMarkFun(val) {
      this.watermark = val;
      let param = {
        warterMark: this.watermark,
        version: "1.0",
        flag: 2,
      };
      this.$emit("savePrintInfo", param);
    },
  },
};
</script>

<style>
#HTMLmachinLeaseContent {
  /* position: relative; */
  width: 20cm;
  padding: 0 10px;
  margin-top: 58px;
  box-shadow: 0px 4px 12px 2px #bbb;
}
p {
  line-height: 29px;
}
.buttons {
  width: 22cm;
  height: 56px;
  position: fixed;
  top: 90px;
  background: white;
}

.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
